/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceNowAssignmentGroupFilter {
    getFixupPrototypeFunction() { return ServiceNowAssignmentGroupFilter.fixupPrototype; }

    static newInstance(model: Partial<ServiceNowAssignmentGroupFilter>): ServiceNowAssignmentGroupFilter {
        let obj = Object.assign(new ServiceNowAssignmentGroupFilter(), model);
        ServiceNowAssignmentGroupFilter.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceNowAssignmentGroupFilter>): ServiceNowAssignmentGroupFilter {
        if (!model) return null;
        return ServiceNowAssignmentGroupFilter.newInstance(<ServiceNowAssignmentGroupFilter> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceNowAssignmentGroupFilter) {
        if (!obj) return;

        models.ServiceNowAssignmentGroupFilter.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceNowAssignmentGroupFilter): boolean {
        Object.setPrototypeOf(obj, ServiceNowAssignmentGroupFilter.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Cloud Service Name
     */
    cloud: models.CloudServiceName;

    /**
     * List of Resource Categories
     */
    resource_categories: Array<string>;

    /**
     * List of Resource Types
     */
    resource_types: Array<string>;

    /**
     * List of Resources
     */
    resources: Array<string>;

}
